import React from "react";
import { Trans } from "react-i18next";
import { advantages } from "../../../utils/data";
import { addS3Url } from "../../../utils/modules";

const TryFreeLanz = () => {
  return (
    <div className="mb-3 mt-3">
      <h3 className="m-0 p-0 mb-4" style={{ fontWeight: "bold" }}>
        <Trans
          i18nKey={"payment.trial_offer"}
          components={{ tag: <span className="color-primary" /> }}
        />
      </h3>
      {advantages.map((data) => (
        <div key={data.id} className="d-flex flex-direction-row mt-2">
          <img
            className="my-1 me-2"
            alt=""
            src={addS3Url("/payment/green-tick.svg")}
            style={{ width: "15px", height: "14px" }}
          />
          <p className="m-0 p-0 text-start" style={{ fontWeight: "600" }}>
            {data?.title}
          </p>
        </div>
      ))}
    </div>
  );
};

export default TryFreeLanz;
